import React from 'react';
import { Link } from 'react-router-dom';

function DropdownProfile() {
	return (
		<div className="menu-item dropdown">
			<a href="#/" className="menu-link dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown">
				<img src="/color-admin/admin/react/assets/img/user/profile.jpg" width="30" height="30" className="object-fit-cover rounded-circle my-n1" alt="" />
				<span className="d-none d-md-inline">
					<span className="d-none d-md-inline">Sean Ngu</span>
					<b className="caret d-none"></b>
				</span>
			</a>
			<div className="dropdown-menu dropdown-menu-end me-1">
				<Link to="/profile" className="dropdown-item">Edit Profile</Link>
				<Link to="/email/inbox" className="dropdown-item d-flex align-items-center">
					Inbox
					<span className="badge bg-danger rounded-pill ms-auto pb-4px">2</span>
				</Link>
				<Link to="/calendar" className="dropdown-item">Calendar</Link>
				<Link to="/settings" className="dropdown-item">Settings</Link>
				<div className="dropdown-divider"></div>
				<Link to="/auth/classic/sign-in" className="dropdown-item">Log Out</Link>
			</div>
		</div>
	);
};

export default DropdownProfile;
